import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'newLine'
})
export class newLine implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\n/g, '<br/>');
 }
}